<ng-container *transloco="let t">
  @if (this.periods.length > 0) {

    <div class="price-holder">
      <div class="title fw-bolder d-flex" app-tooltip
           [tooltip]="{hr: raceCommercialItem?.internalDescription, en: raceCommercialItem?.internalDescriptionEng, it: raceCommercialItem?.internalDescriptionIta, slo: raceCommercialItem?.internalDescriptionSlo}"
           [languages]="languages"
           [position]="TooltipPosition.RIGHT_TOP">

        <app-language-output [hrLabel]="raceCommercialItem?.name" [enLabel]="raceCommercialItem?.nameEng"
                             [itLabel]="raceCommercialItem?.nameIta" [siLabel]="raceCommercialItem?.nameSlo"
                             [defaultLanguage]="event?.defaultLanguage" [languages]="languages"/>
        <div id="tooltipTarget" class="ms-2">
        </div>
      </div>


      <div class="col-xxl-9 col-12">
        <div class="price-table">
          <div class="col-12 d-flex">
            <div class="col-3">
              <div class="col">
                <div class="cell end">
                  <div #prevEl class="pointer"><i class="bi bi-chevron-left cursor-pointer"
                  ></i>
                  </div>
                </div>
                <div class="cell red start">
                <span class="title-content fw-lighter">
                  {{ t("race.pricing.period") }}
                </span></div>
                <div class="cell red start">
                  <span class="content fw-lighter">{{ t("race.pricing.price") }}</span>
                </div>
              </div>
            </div>
            <div class="col-9">
              <swiper #periodsSwiper [slidesPerView]="3" [breakpoints]="breakpoints"
                      [navigation]="{ prevEl: prevEl, nextEl: nextEl }">
                @for (period of periods;track trackByFn;let last = $last;let ind = $index) {
                  <ng-template swiperSlide>
                    <div class="col">
                      <div class="cell center dark">
                    <span class="title-content fw-bolder">
                                   T{{ ind + 1 }}
                    </span>
                      </div>
                      <div class="cell center light">
                    <span class="content">
                      {{ period.startDate | localizedDate:'shortDate' }}
                      -
                      {{ period.endDate | localizedDate:'shortDate' }}
                    </span>
                      </div>
                      <div class="cell center light">
                        <span
                          class="content fw-bolder">{{ period.price ?? "-" }} {{ eventCurrencyLabel | uppercase }}</span>
                      </div>
                    </div>
                  </ng-template>
                }
              </swiper>
            </div>
          </div>
          <div class="col-1">
            <div class="col">
              <div class="cell start ps-0">
                <div #nextEl class="pointer"><i
                  class="bi bi-chevron-right cursor-pointer"
                ></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
</ng-container>

